const CANVA = 'canva';
const UNSPLASH = 'unsplash';
const GIPHY = 'giphy';
const IDEAS = 'ideas';
const DRAG_AND_DROP = 'drag-and-drop';

type OtherSources = {
  name: typeof GIPHY | typeof IDEAS | typeof DRAG_AND_DROP;
};

type CanvaSource = {
  name: typeof CANVA;
  id: string;
};

type UnsplashSource = {
  name: typeof UNSPLASH;
  id: string;
  author: string;
};

const hasProp = <K extends string>(
  obj: unknown,
  key: K
): obj is Record<K, string> => {
  return obj !== null && typeof obj === 'object' && key in obj;
};

const hasStringProp = <K extends string>(
  obj: unknown,
  key: K
): obj is Record<K, string> => {
  return hasProp(obj, key) && typeof obj[key] === 'string';
};

export type UploadSource = OtherSources | UnsplashSource | CanvaSource;

export const UploadSource = {
  new(src?: unknown): UploadSource | undefined {
    if (UploadSource.isCanva(src)) {
      return {
        name: src.name,
        id: src.id,
      };
    }
    if (UploadSource.isUnsplash(src)) {
      return {
        name: src.name,
        id: src.id,
        author: src.author,
      };
    }
    if (UploadSource.isOtherSource(src)) {
      return {
        name: src.name,
      };
    }
  },

  isOtherSource(src: unknown): src is OtherSources {
    return hasStringProp(src, 'name') && src.name === GIPHY;
  },

  isCanva(src?: unknown): src is CanvaSource {
    return (
      hasStringProp(src, 'name') &&
      hasStringProp(src, 'id') &&
      src.name === CANVA &&
      !!src.id
    );
  },

  isUnsplash(src?: unknown): src is UnsplashSource {
    return (
      hasStringProp(src, 'name') &&
      hasStringProp(src, 'id') &&
      hasStringProp(src, 'author') &&
      src.name === UNSPLASH &&
      !!src.id
    );
  },
};
